import { Space, Typography } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import React from 'react';
import CustomForm from '../../../core/components/form/custom-form';
import {
  BasketballTeamAddTeamRequest,
  BasketballTeamsSlice,
  ModalsSlice,
} from '@hefe/store';

export default function AddTeamForm() {
  const dispatch = useAppDispatch();
  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: BasketballTeamAddTeamRequest = {
      name: values.name,
      coaches: [],
    };

    dispatch(setLoading(true));
    dispatch(BasketballTeamsSlice.createBasketballTeam(submitValues))
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <CustomForm
        formId="add-team-form"
        fields={[
          {
            name: 'name',
            label: t('name'),
            type: 'text',
            rules: [
              {
                required: true,
                type: 'string',
                message: t('form_errors.name'),
              },
            ],
          },
        ]}
        onSubmit={onSubmit}
      />
      <Typography.Text>
        {t('information_texts.set_team_settings')}
      </Typography.Text>
    </Space>
  );
}
